import React, { useState } from 'react';
import {
  FiMail,
  FiCheckCircle,
  FiAlertCircle,
} from 'react-icons/fi';
import analyticsService from '../../../services/analytics';
import styles from './Subscribe.module.css';

/* ✅ CRA + TS safe JSX cast */
const Mail = FiMail as unknown as React.FC<{ className?: string }>;
const Check = FiCheckCircle as unknown as React.FC<{ className?: string }>;
const Alert = FiAlertCircle as unknown as React.FC<{ className?: string }>;

const NewsLetter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    if (!name || name.trim().length < 2) {
      setError('Please enter your name');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/newsletter/subscribe`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, name }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        setEmail('');
        setName('');

        analyticsService.trackSubscription(email);
        setTimeout(() => setSuccess(false), 5000);
      } else {
        setError(data.message || 'Subscription failed');
      }
    } catch (err: any) {
      setError('Failed to subscribe. Please try again later');
      analyticsService.trackError(
        'Newsletter subscription failed',
        '/subscribe',
        err?.message
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.newsletterPage}>
      <div className={styles.container}>
        <div className={styles.content}>
          {/* HEADER */}
          <div className={styles.header}>
            <div className={styles.iconWrapper}>
              <Mail className={styles.icon} />
            </div>
            <h1 className={styles.title}>Stay Updated with StartupRahi</h1>
            <p className={styles.subtitle}>
              Get the latest startup news, insights, and exclusive content delivered directly to your inbox.
            </p>
          </div>

          {/* FORM */}
          <div className={styles.formCard}>
            {success ? (
              <div className={styles.successMessage}>
                <Check className={styles.successIcon} />
                <h3>Successfully Subscribed!</h3>
                <p>Thank you for subscribing. Check your email for confirmation.</p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className={styles.form}>
                <div className={styles.formGroup}>
                  <label>Name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading}
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                    required
                  />
                </div>

                {error && (
                  <div className={styles.errorMessage}>
                    <Alert />
                    <span>{error}</span>
                  </div>
                )}

                <button
                  type="submit"
                  className={styles.submitButton}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    'Subscribing...'
                  ) : (
                    <>
                      <Mail />
                      Subscribe Now
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
